
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useLanguage } from "@/contexts/LanguageContext";

const CTASection = () => {
  const { t } = useLanguage();
  
  return (
    <section className="py-20 bg-primary/5 dark:bg-primary/10 transition-colors duration-300">
      <div className="container mx-auto px-6 text-center">
        <h2 className="text-3xl md:text-4xl font-bold mb-6 reveal-on-scroll dark:text-gray-50">
          {t('cta_title')}
        </h2>
        <p className="text-lg text-gray-700 dark:text-gray-300 mb-10 max-w-2xl mx-auto reveal-on-scroll">
          {t('cta_subtitle')}
        </p>
        <div className="reveal-on-scroll">
          <Link to="/arbitrinity">
            <Button size="lg" className="bg-primary hover:bg-primary/90 text-white">
              {t('cta_button')}
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
